/**
 * The Rapier module, loaded on demand. The compat build inlines its WASM in
 * the JavaScript (about 2 MB gzipped), so it is a separate chunk fetched the
 * first time something needs physics (a track, the editor's checks, a
 * replay) instead of part of the page's startup bundle.
 */
type Rapier = (typeof import('@dimforge/rapier3d-compat'))['default'];

let mod: Rapier | null = null;
let loading: Promise<void> | null = null;

/** Loads and initialises Rapier once. Safe to call repeatedly. */
export function loadRapier(): Promise<void> {
  loading ??= import('@dimforge/rapier3d-compat')
    .then(async (m) => {
      await m.default.init();
      mod = m.default;
    })
    .catch((err: unknown) => {
      // Not cached: a failed download (say, a dropped connection) is retried by the next caller.
      loading = null;
      throw err;
    });
  return loading;
}

/** The initialised module; throws if `loadRapier()` (initPhysics) has not resolved. */
export function rapier(): Rapier {
  if (!mod) throw new Error('Physics is not initialised: await initPhysics() first.');
  return mod;
}
